export const logout = (msalInstance, account) => {
    // Clear the session and local storage.
    sessionStorage.clear()
    localStorage.clear()
    msalInstance.logoutRedirect({
        account: account,
        //postLogoutRedirectUri: "/"
    })
    .catch((e) => console.error(e));
}